@if(storeStatus()?.isOpen && !storeStatus()?.isClosedForVacation){
  <cwo-hourglass />
} @else {
  <img [src]="'assets/icons/closed_tag.png' | deployUrl" class="image" [alt]="'Closed Store Image'"/>
}

<span class="title">{{ storeStatus()?.statusMessage }}</span>
